/* eslint-disable react/require-default-props */
import React from 'react';

import { DocumentRequirementsAnalysis } from 'services/ai_management_document_requirements';

interface AiManagementAnalystStatusProps {
  analysis: DocumentRequirementsAnalysis | null;
  reanalyzing: boolean;
  reanalyzeError: string;
  onReanalyze: () => void;
  processingMessage?: React.ReactNode;
  errorHint?: string;
  errorActions?: React.ReactNode;
}

const DEFAULT_PROCESSING_MESSAGE = (
  <>
    <strong>Analisando…</strong> O Analista de Habilitação está procurando, entre os seus
    documentos, os mais compatíveis com cada exigência. As sugestões aparecem aqui quando a análise
    terminar.
  </>
);

const DEFAULT_ERROR_HINT = 'Você pode continuar adicionando os documentos manualmente.';

const AiManagementAnalystStatus: React.FC<AiManagementAnalystStatusProps> = ({
  analysis,
  reanalyzing,
  reanalyzeError,
  onReanalyze,
  processingMessage = DEFAULT_PROCESSING_MESSAGE,
  errorHint = DEFAULT_ERROR_HINT,
  errorActions,
}) => {
  if (!analysis) return null;

  if (analysis.status === 'processing') {
    return (
      <div className="alert alert-info d-flex align-items-center mb-3" role="status">
        <span className="spinner-border spinner-border-sm mr-2 flex-shrink-0" aria-hidden="true" />
        <span>{processingMessage}</span>
      </div>
    );
  }

  if (analysis.status === 'error') {
    return (
      <div className="alert alert-danger mb-3" role="alert">
        <div className="d-flex align-items-center justify-content-between">
          <span>
            {analysis.errorMessage}
            {errorHint && ` ${errorHint}`}
          </span>
          <div className="d-flex flex-shrink-0 ml-3">
            <button
              type="button"
              className="btn btn-sm btn-outline-danger"
              onClick={onReanalyze}
              disabled={reanalyzing}
            >
              Analisar de novo
            </button>
            {errorActions}
          </div>
        </div>
        {reanalyzeError && <p className="mb-0 mt-2">{reanalyzeError}</p>}
      </div>
    );
  }

  const partial = analysis.status === 'partial';
  if (!partial && !analysis.warnings.length) return null;

  return (
    <div className="alert alert-warning mb-3" role="status">
      {partial && (
        <p className={analysis.warnings.length ? 'mb-1' : 'mb-0'}>
          A análise terminou, mas algumas exigências ficaram sem parecer do Analista. Revise essas
          exigências manualmente.
        </p>
      )}
      {analysis.warnings.length > 0 && (
        <ul className="mb-0 pl-3">
          {analysis.warnings.map((warning) => (
            <li key={warning}>{warning}</li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default AiManagementAnalystStatus;
